export default __webpack_public_path__ + "static/EEW-Authorship-e356ac165eec3f99e48314498042b431.png";